import '../../../../node_modules/chosen-js/chosen.jquery.js'

$(".chosen-select").chosen({ width: "100%" });
$(".orange-arrow .chosen-container-single .chosen-single").addClass("orange");
/*=======================================
    VARIABLES
=======================================*/
var state = $("#state option:selected");
var emailReg = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
var phoneReg = /^[01]?[- .]?(\([2-9]\d{2}\)|[2-9]\d{2})[- .]?\d{3}[- .]?\d{4}$/;///^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
var nmlsReg = /^\d{4,7}$/;

var fname = true,
    lname = true,
    email = true,
    zipcode = true,
    radio = true,
    state = true,
    interested = true,
    phone = true,
    branch = true,
    name = true,
    company = true,
    businessaddress = true,
    isagreed = true,
    streetaddress = true,
    city = true,
    location = true,
    militarystatus = true,
    ownahome = true,
    //propertyaddress = true,
    offer = true,
    downpayment = true,
    dob = true,
    captcha = true,
    feedback = true,
    address = true,
    nmlsNumber = true,
    loanofficer = true,
    yearstarted = true,
    businesshours = true;

var ariaState = "state dropdown list, please select one of the 49 options";
var ariaQuestion = "Please select from one of the options below";
var ariaSearchState = "Search by branch name, please select one of the 49 options";
var ariamilitaryStatus = "Military status dropdown list, please select one of the 5 options";
var ariaownAHome = "Do you currently own a home dropown list, please select one of the 4 options";
var ariaSearchLO = "Search by loan officer name, please select loan officer";


async function generateCaptchaKey(formtype) {
    // --- reCAPTCHA v3: execute and get token ---
    let captchaToken;
    try {
        captchaToken = await grecaptcha.enterprise.execute('6Lc0VPUsAAAAAB9wa0NuA-T8Ko1IGn06U9-HsSr-', { action: formtype });
        return captchaToken;
    } catch (err) {
        console.error('reCAPTCHA execution failed', err);
        $('.captcha-error').show();
        $(this).show();
        return ''; // Stop submission if reCAPTCHA itself errors
    }
}

/*=======================================
     FIELDS VALIDATION
=======================================*/
$("input[name='fname']").on('focusout change', function () {
    if ($(this).val().trim() == "") {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        fname = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        fname = false;
    }
});

$("input[name='name']").blur(function () {
    if ($(this).val().trim() == "") {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        name = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        name = false;
    }
});

$("input[name='location']").on('focusout change', function () {
    if ($(this).val().trim() == "") {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        location = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        location = false;
    }
});

$("input[name='StreetAddress']").blur(function () {
    if ($(this).val().trim() == "") {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        streetaddress = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        streetaddress = false;
    }
});

//$("input[name='propertyaddress']").blur(function () {
//    if ($(this).val().trim() == "") {
//        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
//        $(this).addClass('red-border');
//        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
//        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
//        propertyaddress = true;
//    } else {
//        $(this).removeClass('red-border');
//        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
//        propertyaddress = false;
//    }
//});
$("#feedbackform #address").on('focusout change', function () {
    if ($(this).val().trim() == "") {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        address = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        address = false;
    }
});

$("#feedbackform #feedback").on('blur', function () {
    if ($(this).val().trim() == "") {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        feedback = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        feedback = false;
    }
});
$("input[name='offer']").blur(function () {
    if ($(this).val().trim() == "") {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        offer = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        offer = false;
    }
});
$("input[name='downpayment']").blur(function () {
    if ($(this).val().trim() == "") {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        downpayment = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        downpayment = false;
    }
});
$("input[name='company']").blur(function () {
    if ($(this).val().trim() == "") {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        company = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        company = false;
    }
});

$("input[name='company']").on('focusout change', function () {
    if ($(this).val().trim() == "") {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        company = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        company = false;
    }
});


$("input[name='lname']").on('focusout change', function () {
    if ($(this).val().trim() == "") {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        lname = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        lname = false;
    }
});

$("input[name='email']").on('focusout change', function () {
    if ($(this).val() == "" || !emailReg.test($(this).val())) {
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage;
        if ($(this).val() == "") {
            validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        } else if (!emailReg.test($(this).val())) {
            validationMessage = $(this).closest("div")[0].dataset.emailValidationMessage;
        }
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        email = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        email = false;
    }
});

$("input[name='zip']").on('focusout change', function () {
    if ($(this).val().length < 5) {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        zipcode = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        zipcode = false;
    }
});

$("input[name='City']").on('focusout change', function () {
    if ($(this).val().trim() == "") {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        city = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        city = false;
    }
});

$("#FindLoanOfficer #state").chosen().change(function () {
    if ($("#state option:selected").val() == "") {
        $(".chosen-container-single .chosen-single").addClass('red-border');
        state = true;
        $("#state").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariaSearchState);
    } else {
        var ariaSelected = $("#state option:selected").text().trim() + " selected";
        $(".chosen-container-single .chosen-single").removeClass('red-border');
        state = false;
        $("#state").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariaSelected);
    }
});

$("#state").chosen().change(function () {
    if ($("#state option:selected").val() == "") {
        $(".chosen-container-single .chosen-single").addClass('red-border');
        state = true;
        $("#state").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariaState);
    } else {
        var ariaSelected = $("#state option:selected").text().trim() + " selected";
        $(".chosen-container-single .chosen-single").removeClass('red-border');
        $('.chosen-container-single').removeClass('red-border');
        $(this).closest("div.col-xs-6").find("span.field-validation-valid").addClass("d-none");
        state = false;
        $("#state").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariaSelected);
    }
});
/* Sitecore Forms Dropdownlist */
$(".ddlrequired").chosen().change(function () {
    if ($(".ddlrequired option:selected").val() == "") {
        $(".chosen-container-single .chosen-single").addClass('red-border');
        state = true;
        $(".ddlrequired").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariaState);
    } else {
        var ariaSelected = $(".ddlrequired option:selected").text().trim() + " selected";
        $(".chosen-container-single .chosen-single").removeClass('red-border');
        $('.chosen-container-single').removeClass('red-border');
        $(this).closest("div.col-xs-6").find("span.field-validation-valid").addClass("d-none");
        state = false;
        $(".ddlrequired").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariaSelected);
    }
});

$("#militarystatus").chosen().change(function () {
    if ($("#militarystatus option:selected").val() == "") {
        $(".chosen-container-single .chosen-single").addClass('red-border');
        militarystatus = true;
        $("#militarystatus").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariamilitaryStatus);
    } else {
        var ariaSelected = $("#militarystatus option:selected").text().trim() + " selected";
        $(".chosen-container-single .chosen-single").removeClass('red-border');
        $('.chosen-container-single').removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        militarystatus = false;
        $("#militarystatus").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariaSelected);
    }
});

$("#militarystatus").blur(function () {
    if ($("#militarystatus option:selected").val() == "") {
        $("#militarystatus").parent().find('.chosen-container-single').addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        militarystatus = true;
        return;
    } else {
        $("#militarystatus").parent().find('.chosen-container-single').removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        militarystatus = false;
        return;
    }
});

$("#isownhome").chosen().change(function () {
    if ($("#isownhome option:selected").val() == "") {
        $(".chosen-container-single .chosen-single").addClass('red-border');
        ownahome = true;
        $("#isownhome").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariaownAHome);
    } else {
        var ariaSelected = $("#isownhome option:selected").text().trim() + " selected";
        $(".chosen-container-single .chosen-single").removeClass('red-border');
        $('.chosen-container-single').removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        ownahome = false;
        $("#isownhome").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariaSelected);
    }
});

$("#isownhome").blur(function () {
    if ($("#isownhome option:selected").val() == "") {
        $("#isownhome").parent().find('.chosen-container-single').addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        ownahome = true;
        return;
    } else {
        $("#isownhome").parent().find('.chosen-container-single').removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        ownahome = false;
        return;
    }
});

$("input[name='dob']").on('focusout change', function () {
    if ($(this).val().trim() == "") {
        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        dob = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        dob = false;
    }
});
$("#question").chosen().change(function () {
    if ($("#question option:selected").val() == "") {
        $(".chosen-container-single .chosen-single").addClass('red-border');
        state = true;
        $("#question").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariaQuestion);
    } else {
        var ariaSelected = $("#question option:selected").text().trim() + " selected";
        $(".chosen-container-single .chosen-single").removeClass('red-border');
        state = false;
        $("#question").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariaSelected);
    }
});

$(document).on('keydown', function (event) {
    if (event.keyCode == '40') {
        if ($(event.target).is(".chosen-container") || $(event.target).is(".chosen-container *")) {
            $(event.target).closest(".chosen-container").siblings(".chosen-select").trigger('chosen:open');
        }
    }
});

$(document).on('keyup', function (event) {
    if (event.keyCode != '') {
        if ($(event.target).is(".chosen-container") || $(event.target).is(".chosen-container *")) {
            $(event.target).closest(".chosen-container").siblings(".chosen-select").trigger('chosen:open');
        }
    }
});

$("#branch").on('change', function () {
    if ($("#branch option:selected").val() == "") {
        $(".chosen-container-single .chosen-single").addClass('red-border');
        branch = true;
    } else {
        $(".chosen-container-single .chosen-single").removeClass('red-border');
        branch = false;
    }
});

$("input[name='phone']").on('focusout change', function () {
    if ($(this).val() == "" || !phoneReg.test($(this).val())) { //$(this).val().length <= 19
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage;
        if ($(this).val() == "") {
            validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
        } else if (!phoneReg.test($(this).val())) {
            validationMessage = $(this).closest("div")[0].dataset.phoneValidationMessage;
        }
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        phone = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        phone = false;
    }
});

var productTypeGet = false;
$("input[name='ProductType']").on('focusout change', function () {
    if (productTypeGet == true || $(this).is(':checked')) {
        productTypeGet = true;
        $("input[name='ProductType']").parent().parent().parent().removeClass('red-border');
        $(this).closest(".row.input-row").find("span.field-validation-valid").addClass("d-none");
        radio = false;
    } else {
        var validationMessage = $(this).closest(".row.input-row")[0].dataset.requiredMessage;
        $("input[name='ProductType']").parent().parent().parent().addClass('red-border');
        $(this).closest(".row.input-row").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest(".row.input-row").find("span.field-validation-valid").text(validationMessage);
        radio = true;
    }
});

$("input[name='IsAgreed']").blur(function () {
    if (!$("input[name='IsAgreed']").is(':checked')) {
        $("input[name='IsAgreed']").parent().addClass('red-border');
        isagreed = true;
    }
    else {
        $("input[name='IsAgreed']").parent().removeClass('red-border');
        isagreed = false;
    }
});

$("input[name='zip'], input[name='homePhone'], input[name='mobilePhone'], input[name='workPhone']").keypress(function (e) {
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        return false;
    }
});


$("input[name='fname']").keyup(function () {
    if ($(this).val().trim() == "") {
        $(this).addClass('red-border');
        fname = true;
    }
    else {
        $(this).removeClass('red-border');
        fname = false;
    }

});

$("input[name='lname']").keyup(function () {
    if ($(this).val().trim() == "") {
        $(this).addClass('red-border');
        lname = true;
    }
    else {
        $(this).removeClass('red-border');
        lname = false;
    }
});


/*=======================================
    SUBMIT BUTTON
=======================================*/
$("#submitBtn").on('click', async function (event) {
    event.preventDefault();
    $(this).hide();
    if ($("#state option:selected").val() == "") {
        $(".chosen-container-single .chosen-single").addClass('red-border');
        state = true;
    }


    let captchaToken = await generateCaptchaKey('QuoteForm');

    if (captchaToken != '') {
        // Inject the token into your hidden field for server-side verification
        document.getElementById('g-recaptcha-response').value = captchaToken;
        captcha = false;
        $('.captcha-error').hide();
    } else {
        $('.captcha-error').show();
        captcha = true;
    }
    // --- end reCAPTCHA v3 block ---
    //if ($("#hdnLoanOfficerID").val() != "") {
    //    var captcharesponse = grecaptcha.getResponse();
    //    if (captcharesponse.length != 0) {
    //        captcha = false;
    //        $('.captcha-error').hide();
    //    }
    //    else {
    //        $('.captcha-error').show();
    //        captcha = true;
    //    }
    //}
    //else {
    //    captcha = false;
    //}


    if ($("input[name='productset']").length) {
        radio = false;
        if (fname === true || lname === true || email === true || state === true || zipcode === true || phone === true) {

            $("input[name='fname'],input[name='lname'],input[name='email'],input[name='zip'],#state,input[name='phone']").blur();
            $(this).show();
            document.getElementById("formValidationSummary").classList.remove("d-none");
            $("#formValidationSummaryContainer")[0].focus();
        }
        else {
            $("#divWait").show();
            $(".field-validation-valid.text-danger").addClass("d-none");
            $("#submitBtn").closest("form")[0].submit();
        }
    }
    else {
        if (fname === true || lname === true || email === true || state === true || zipcode === true || phone === true || radio === true) {

            $("input[name='fname'],input[name='lname'],input[name='email'],input[name='zip'],#state,input[name='phone'],input[name='ProductType']").blur();
            $(this).show();
            document.getElementById("formValidationSummary").classList.remove("d-none");
            $("#formValidationSummaryContainer")[0].focus();
        }
        else {
            $("#divWait").show();
            $(".field-validation-valid.text-danger").addClass("d-none");
            $("#submitBtn").closest("form")[0].submit();
        }
    }
});


$("#submitlocustomerform").on('click', async function (event) {
    event.preventDefault();
    let captchaToken = await generateCaptchaKey('LOCustomerForm');

    if (captchaToken != '') {
        // Inject the token into your hidden field for server-side verification
        document.getElementById('g-recaptcha-response').value = captchaToken;
        captcha = false;
        $('.captcha-error').hide();
    } else {
        $('.captcha-error').show();
        captcha = true;
    }
    // --- end reCAPTCHA v3 block ---

    $(this).hide();

    if (name === true || email === true || phone === true || captcha == true) {
        $("input[name='name'],input[name='email'],input[name='phone']").blur();
        $(this).show();
        document.getElementById("formValidationSummary").classList.remove("d-none");
        $("#formValidationSummaryContainer")[0].focus();
    }
    else {
        $("#divWait").show();
        $(".field-validation-valid.text-danger").addClass("d-none");
        // Trigger the actual form submission now that token is in place
        $("#submitlocustomerform").closest("form")[0].submit();
    }
});
/* Sitecore Forms Submit */
$(".fsubmit").on('click', function (event) {
    if ($(".ddlrequired option:selected").val() == "") {
        $(".chosen-container-single .chosen-single").addClass('red-border');
        $(".ddlrequired").closest("div.col-xs-6").find("span.field-validation-valid").removeClass("d-none");
        state = true;
    }
});


if ($("#GOTCForm").length > 0) {

    var popupendpoint = gotcPopup_endpoint;

    var gotcData = {
        name: '',
        email: '',
        phone: '',
        bestdate: '',
        besttime: ''
    };

    var besttime = false;

    $("#GOTCForm input[name='BestTime']").blur(function () {
        if ($(this).val().trim() == "") {
            $(this).addClass('red-border');
            besttime = true;
        }
        else {
            $(this).removeClass('red-border');
            besttime = false;
        }

    });

    $('#btnSubmitGOTCPopup').click(function () {


        if (name === true || email === true || phone == true || besttime === true) {
            event.preventDefault();
            $("input[name='name'],input[name='email'],input[name='phone'],#GOTCForm input[name='BestTime']").blur();
            return false;
        }
        $(this).hide();
        $("#divWait").show();
        gotcData.name = $('#GOTCForm').find('#name').val();

        gotcData.email = $('#GOTCForm').find('#email').val();
        gotcData.phone = $('#GOTCForm').find('#phone').val();
        gotcData.bestdate = $('#GOTCForm').find('#BestDate').val();
        gotcData.besttime = $('#GOTCForm').find('#BestTime').val();;
        gotcData.pageurl = window.location.href;

        $.ajax({
            url: popupendpoint,
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify(gotcData),
            contentType: 'application/json; charset=utf-8',
            success: function (data) {
                $("#GOTCForm input[type='text'").val('');
                $('#GOTCForm').hide();
                $('#gotcthankyou').show();
                return data;
            }
        });
    });

}

/*=======================================
    TUQuote Form SUBMIT BUTTON
=======================================*/

$(".TUQuoteForm #state").blur(function () {
    if ($("#GetAQuote #state option:selected").val() == "") {
        $("#GetAQuote #state").parent().find('.chosen-container-single').addClass('red-border');
        $(this).closest("div.col-xs-6").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage = $(this).closest("div.col-xs-6")[0].dataset.requiredMessage;
        $(this).closest("div.col-xs-6").find("span.field-validation-valid").text(validationMessage);
        state = true;
        return;
    } else {
        $("#GetAQuote #state").parent().find('.chosen-container-single').removeClass('red-border');
        $(this).closest("div.col-xs-6").find("span.field-validation-valid").addClass("d-none");
        state = false;
        return;
    }
});

$(".TUQuoteForm #submit").on('click', function (event) {
    $(this).hide();
    if (fname === true || lname === true || email === true || state === true || zipcode === true || phone === true || radio === true || isagreed == true || streetaddress == true || city == true) {
        event.preventDefault();
        $("input[name='fname'],input[name='lname'],input[name='email'],input[name='zip'],#state,input[name='phone'],input[name='IsAgreed'],input[name='StreetAddress'],input[name='City']").blur();
        $(this).show();

        document.getElementById("formValidationSummary").classList.remove("d-none");
        $("#formValidationSummaryContainer")[0].focus();
    }
    else {
        $("#divWait").show();
    }
});
$(".AVMFormPanel #state").on('focusout change', function () {
    if ($(".AVMFormPanel #state option:selected").val() == "") {
        $(".AVMFormPanel #state").parent().find('.chosen-container-single').addClass('red-border');
        $(this).closest("div.col-xs-4").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage = $(this).closest("div.col-xs-4")[0].dataset.requiredMessage;
        $(this).closest("div.col-xs-4").find("span.field-validation-valid").text(validationMessage);
        state = true;
        return;
    } else {
        $(".AVMFormPanel #state").parent().find('.chosen-container-single').removeClass('red-border');
        $(this).closest("div.col-xs-4").find("span.field-validation-valid").addClass("d-none");
        state = false;
        return;
    }
});
$(".AVMFormPanel .submit").on('click', function (event) {
    $(this).hide();
    if (fname === true || lname === true || email === true || phone === true || offer === true || downpayment == true || state === true || zipcode === true || city == true || streetaddress == true) {
        event.preventDefault();
        $("input[name='fname'],input[name='lname'],input[name='email'],input[name='offer'],input[name='phone'],input[name='downpayment'],#state,input[name='zip'],input[name='City'],input[name='StreetAddress']").blur();
        $(this).show();

        document.getElementById("formValidationSummary").classList.remove("d-none");
        $("#formValidationSummaryContainer")[0].focus();
    }
    else {
        $("#divWait").show();
        $(".field-validation-valid.text-danger").addClass("d-none");
    }
});

/**********/
/****Holiday Donations Form Submit*****/
/**********/
if ($("#donationform").length > 0) {

    var donationendpoint = donation_endpoint;
    var charityOrgGet = false;


    var donationData = {
        fname: '',
        lname: '',
        email: '',
        charityorg: ''

    };

    $("input[name='charityorg']").on('focusout change', function () {
        if (charityOrgGet == true || $(this).is(':checked')) {
            charityOrgGet = true;
            $("input[name='charityorg']").parent().parent().parent().parent().removeClass('red-border');
            $(this).closest(".row.input-row").find("span.field-validation-valid").addClass("d-none");
            radio = false;
        } else {
            var validationMessage = $(this).closest(".row.input-row")[0].dataset.requiredMessage;
            $("input[name='charityorg']").parent().parent().parent().parent().addClass('red-border');
            $(this).closest(".row.input-row").find("span.field-validation-valid").removeClass("d-none");
            $(this).closest(".row.input-row").find("span.field-validation-valid").text(validationMessage);
            radio = true;
        }
    });

    $(".donationform #btnSubmitDonation").on('click', function (event) {
        $(this).hide();
        if (fname === true || lname === true || email === true || radio === true) {
            event.preventDefault();
            $("input[name='fname'],input[name='lname'],input[name='email'],input[name='charityorg']").blur();
            $(this).show();

            document.getElementById("formValidationSummary").innerHTML = "Please correct the form errors and try again.";
            document.getElementById("formValidationSummary").classList.remove("d-none");
            $("#formValidationSummaryContainer")[0].focus();
        }
        else {
            $("#divWait").show();
            $(".field-validation-valid.text-danger").addClass("d-none");

            donationData.fname = $('#donationform').find('#fname').val();
            donationData.lname = $('#donationform').find('#lname').val();
            donationData.email = $('#donationform').find('#email').val();
            donationData.charityorg = $('#donationform').find('input[name="charityorg"]:checked').val();
            donationData.pageurl = window.location.href;

            $.ajax({
                url: donationendpoint,
                type: 'POST',
                dataType: 'json',
                data: JSON.stringify(donationData),
                contentType: 'application/json; charset=utf-8',
                success: function (data) {
                    $("#donationform input[type='text']").val('');
                    $("#donationform input[type='text']").prop("disabled", true);
                    $('#donationthankyoubutton').click();
                    $("#divWait").hide();
                    $(".donationform #btnSubmitDonation").show();
                    $(".donationform #btnSubmitDonation").prop("disabled", true);
                    $("input[name='charityorg']").each(function (i) {
                        $(this).attr('disabled', 'disabled');
                        $(this).prop('checked', false);
                    });
                    return data;
                },
                error: function (data) {
                    if (data.status == 400) {
                        event.preventDefault();
                        $("#divWait").hide();
                        $(".donationform #btnSubmitDonation").show();
                        document.getElementById("formValidationSummary").innerHTML = "It seems we have already received your donation selection and email address. Thank you."
                        document.getElementById("formValidationSummary").classList.remove("d-none");
                        $("#formValidationSummaryContainer")[0].focus();
                    }
                }
            });
        }
    });


}

/*=========================================
 * Loan Officer Apply Prequal Buttons Click
 * =======================================*/

$(".locontactme").on('click', function (event) {
    var loapplyContactMeClickedendpoint = loApplyContactMeClicked_endpoint;

    var clickedData = {
        ButtonType: 'contactme'
    };
    $.ajax({
        url: loapplyContactMeClickedendpoint,
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(clickedData),
        contentType: 'application/json; charset=utf-8',
        success: function (data) {

            return data;
        },
        error: function (data) {

        }
    });

});

$(".loapplynowclicked").on('click', function (event) {
    var loapplyContactMeClickedendpoint = loApplyContactMeClicked_endpoint;

    var clickedData = {
        ButtonType: 'applynow'
    };
    $.ajax({
        url: loapplyContactMeClickedendpoint,
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(clickedData),
        contentType: 'application/json; charset=utf-8',
        success: function (data) {

            return data;
        },
        error: function (data) {

        }
    });

});


/*=======================================
    Recruiting Talk Form Validation
========================================*/
$(".recruiting-talk-form .submit").on('click', function (event) {
    if ($("#state option:selected").val() == "") {
        $(".chosen-container-single .chosen-single").addClass('red-border');
        state = true;
    }
    if (fname === true || lname === true || email === true || state === true || zipcode === true || phone === true) {
        event.preventDefault();
        $("input[name='fname'],input[name='lname'],input[name='email'],input[name='zip'],#state,input[name='phone']").blur();
    }
});

$("#GetAQuote #state").on('focusout change', function () {
    if ($("#GetAQuote #state option:selected").val() == "") {
        $("#GetAQuote #state").parent().find('.chosen-container-single').addClass('red-border');
        $(this).closest("div.col-xs-6").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage = $(this).closest("div.col-xs-6")[0].dataset.requiredMessage;
        $(this).closest("div.col-xs-6").find("span.field-validation-valid").text(validationMessage);
        state = true;
        return;
    } else {
        $("#GetAQuote #state").parent().find('.chosen-container-single').removeClass('red-border');
        $(this).closest("div.col-xs-6").find("span.field-validation-valid").addClass("d-none");
        state = false;
        return;
    }
});

$("#LOQuoteForm #state, #LOQuoteForm .chosen-focus-input").blur(function () {
    if ($("#LOQuoteForm #state option:selected").val() == "") {
        $("#LOQuoteForm #state").parent().find('.chosen-container-single').addClass('red-border');
        $(this).closest("div.col-xs-6,div.col-xs-12").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage = $(this).closest("div.col-xs-6,div.col-xs-12")[0].dataset.requiredMessage;
        $(this).closest("div.col-xs-6,div.col-xs-12").find("span.field-validation-valid").text(validationMessage);
        state = true;
    } else {
        $("#LOQuoteForm #state").parent().find('.chosen-container-single').removeClass('red-border');
        $(this).closest("div.col-xs-6,div.col-xs-12").find("span.field-validation-valid").addClass("d-none");
        state = false;
    }
});

$("#LOQuoteForm input[type='submit']").on('click', function (event) {
    if (fname === true || lname === true || email === true || state === true || zipcode === true || phone === true) {
        event.preventDefault();
        $("input[name='fname'],input[name='lname'],input[name='email'],input[name='zip'],#state,input[name='phone']").blur();

        document.getElementById("formValidationSummary").classList.remove("d-none");
        $("#formValidationSummaryContainer")[0].focus();
    }
});

/*======================================
Realtor Form Validation
========================================*/

$(".realtor-form .submit").on('click', function (event) {
    $(this).hide();
    if ($("#branch option:selected").val() == "") {
        $(".chosen-container-single .chosen-single").addClass('red-border');
        branch = true;
    }
    if (name === true || company === true || email === true || branch === true || phone === true) {
        event.preventDefault();
        $("input[name='name'],input[name='company'],input[name='email'],#branch,input[name='phone']").blur();
        $(this).show();
    }
    else {
        $("#divWait").show();
    }
});

/*=======================================
    CONTACT US VALIDATION
=======================================*/
$(".contact-us-form input.required").blur(function () {
    if ($(this).attr("name") == "email") {
        if ($(this).val() == "" || !emailReg.test($(this).val())) {
            $(this).addClass('red-border');
            $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
            var validationMessage;
            if ($(this).val() == "") {
                validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
            } else if (!emailReg.test($(this).val())) {
                validationMessage = $(this).closest("div")[0].dataset.emailValidationMessage;
            }
            $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
            email = true;
        } else {
            $(this).removeClass('red-border');
            $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
            email = false;
        }
    }
    if ($(this).attr("name") == "fname" || $(this).attr("name") == "lname") {
        if ($(this).val().trim() == "") {
            var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
            $(this).addClass('red-border');
            $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
            $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
            lname = true;
        } else {
            $(this).removeClass('red-border');
            $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
            lname = false;
        }
    }
    if ($(this).attr("name") == "zip") {
        if ($(this).val().length < 5) {
            var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
            $(this).addClass('red-border');
            $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
            $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
            zipcode = true;
        } else {
            $(this).removeClass('red-border');
            $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
            zipcode = false;
        }
    }
});

$("input[name='workPhone']").blur(function () {
    if (($(this).val() != "" && !phoneReg.test($(this).val())) || ($(this).val() != "" && $(this).val().length < 10)) {
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage = $(this).closest("div")[0].dataset.phoneValidationMessage;
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
    }
    else if ($(this).val() == "" || phoneReg.test($(this).val())) {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
    }
});

$("input[name='mobilePhone']").blur(function () {
    if (($(this).val() != "" && !phoneReg.test($(this).val())) || ($(this).val() != "" && $(this).val().length < 10)) {
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage = $(this).closest("div")[0].dataset.phoneValidationMessage;
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
    }
    else if ($(this).val() == "" || phoneReg.test($(this).val())) {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
    }
});

$("input[name='homePhone']").blur(function () {
    if (($(this).val() != "" && !phoneReg.test($(this).val())) || ($(this).val() != "" && $(this).val().length < 10)) {
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage = $(this).closest("div")[0].dataset.phoneValidationMessage;
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
    }
    else if ($(this).val() == "" || phoneReg.test($(this).val())) {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
    }
});

$(".state-select, .state-list .chosen-focus-input").blur(function () {
    if ($(".state-select option:selected").val() == "") {
        $(".state-select").parent().find('.chosen-container-single').addClass('red-border');
        $(this).closest("div.col-md-3").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage = $(this).closest("div.col-md-3")[0].dataset.requiredMessage;
        $(this).closest("div.col-md-3").find("span.field-validation-valid").text(validationMessage);
        state = true;
    } else {
        $(".state-select").parent().find('.chosen-container-single').removeClass('red-border');
        $(this).closest("div.col-md-3").find("span.field-validation-valid").addClass("d-none");
        state = false;
    }
});

$(".interested-select, .question-list .chosen-focus-input").blur(function () {
    if ($(".interested-select option:selected").val() == "") {
        $(".interested-select").parent().find('.chosen-container-single').addClass('red-border');
        $(this).closest("div.question-list").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage = $(this).closest("div.question-list")[0].dataset.requiredMessage;
        $(this).closest("div.question-list").find("span.field-validation-valid").text(validationMessage);
        interested = true;
    } else {
        $(".interested-select").parent().find('.chosen-container-single').removeClass('red-border');
        $(this).closest("div.question-list").find("span.field-validation-valid").addClass("d-none");
        interested = false;
    }
});

$(".contact-us-form .submit").on('click', async function (event) {
    event.preventDefault();
    let captchaToken = await generateCaptchaKey('ContactUs');

    if (captchaToken != '') {
        // Inject the token into your hidden field for server-side verification
        document.getElementById('g-recaptcha-response').value = captchaToken;
        captcha = false;
        $('.captcha-error').hide();
    } else {
        $('.captcha-error').show();
        captcha = true;
    }

    $("input.required, .interested-select, .state-select").blur();
    // --- end reCAPTCHA v3 block ---
    if (fname === true || lname === true || email === true ||
        state === true || zipcode === true || interested == true || captcha == true) {


        document.getElementById("formValidationSummary").classList.remove("d-none");
        $("#formValidationSummaryContainer")[0].focus();
    }
    else {
        document.getElementById("formValidationSummary").classList.add("d-none");
        $(".contact-us-form .submit").closest("form")[0].submit();
    }


});
$("#feedbackform .submit").on('click', async function (event) {
    event.preventDefault();
    let captchaToken = await generateCaptchaKey('FeedbackForm');

    if (captchaToken != '') {
        // Inject the token into your hidden field for server-side verification
        document.getElementById('g-recaptcha-response').value = captchaToken;
        captcha = false;
        $('.captcha-error').hide();
    } else {
        $('.captcha-error').show();
        captcha = true;
    }
    // --- end reCAPTCHA v3 block ---

    if (name === true || email === true || address === true || feedback == true || captcha == true) {

        $("input.required, #feedbackform #address, #feedbackform #feedback").blur();

        document.getElementById("formValidationSummary").classList.remove("d-none");
        $("#formValidationSummaryContainer")[0].focus();
    }
    else {
        $("#feedbackform .submit").closest("form")[0].submit();
    }
});

$("#BuilderSuccessForm #state, #BuilderSuccessForm .chosen-focus-input").blur(function () {
    if ($("#BuilderSuccessForm #state option:selected").val() == "") {
        $("#BuilderSuccessForm #state").parent().find('.chosen-container-single').addClass('red-border');
        $(this).closest("div.col-xs-6,div.col-xs-12").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage = $(this).closest("div.col-xs-6,div.col-xs-12")[0].dataset.requiredMessage;
        $(this).closest("div.col-xs-6,div.col-xs-12").find("span.field-validation-valid").text(validationMessage);
        state = true;
    } else {
        $("#BuilderSuccessForm #state").parent().find('.chosen-container-single').removeClass('red-border');
        $(this).closest("div.col-xs-6,div.col-xs-12").find("span.field-validation-valid").addClass("d-none");
        state = false;
    }
});
$("#BuilderSuccessForm .submit").on('click', async function (event) {
    event.preventDefault();
    let captchaToken = await generateCaptchaKey('BuilderSuccessQuote');

    if (captchaToken != '') {
        // Inject the token into your hidden field for server-side verification
        document.getElementById('g-recaptcha-response').value = captchaToken;
        captcha = false;
        $('.captcha-error').hide();
    } else {
        $('.captcha-error').show();
        captcha = true;
    }

    if (fname === true || lname === true || email === true || phone === true || state === true || zipcode === true || company === true || captcha == true) {
        $("input[name='fname'],input[name='lname'],input[name='email'],input[name='zip'],#state,input[name='phone'],input[name='company']").blur();

        document.getElementById("formValidationSummary").classList.remove("d-none");
        $("#formValidationSummaryContainer")[0].focus();
    }
    else {
        $("#BuilderSuccessForm .submit").closest("form")[0].submit();
    }
});

$(".recruiting-talk-form input[type='submit']").on('click', function (event) {
    if (fname === true || lname === true || email === true || state === true || zipcode === true || phone === true) {
        event.preventDefault();
        $("input.required").blur();

        document.getElementById("formValidationSummary").classList.remove("d-none");
        $("#formValidationSummaryContainer")[0].focus();
    }
});

/*********************/
/****Recruitment Schedule Form****/
/********************/
$("input[name='nmlsNumber']").blur(function () {
    var value = $(this).val().trim();
    var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
    var invalidFormatMessage = $(this).closest("div")[0].dataset.invalidMessage; // add this data attribute in your HTML, or hardcode a string below

    if (value == "") {
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
        nmlsNumber = true;
    } else if (!nmlsReg.test(value)) {
        $(this).addClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
        $(this).closest("div").find("span.field-validation-valid").text(invalidFormatMessage || "Must be 4 to 7 digits.");
        nmlsNumber = true;
    } else {
        $(this).removeClass('red-border');
        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
        nmlsNumber = false;
    }
});

$(".recruitment-schedule-form .submit").on('click', async function (event) {
    event.preventDefault();
    let captchaToken = await generateCaptchaKey('RecruitingForm');

    if (captchaToken != '') {
        // Inject the token into your hidden field for server-side verification
        document.getElementById('g-recaptcha-response').value = captchaToken;
        captcha = false;
        $('.captcha-error').hide();
    } else {
        $('.captcha-error').show();
        captcha = true;
    }

    $(this).hide();
    if (name === true || email === true || phone === true || location === true || captcha == true || nmlsNumber == true) {

        $("input[name='name'],input[name='email'],input[name='phone'],input[name='location'], input[name='nmlsNumber']").blur();
        $(this).show();

        document.getElementById("formValidationSummary").classList.remove("d-none");
        $("#formValidationSummaryContainer")[0].focus();
    }
    else {
        $("#divWait").show();
        $(".field-validation-valid.text-danger").addClass("d-none");
        $(".recruitment-schedule-form .submit").closest("form")[0].submit();
    }
});

/*********************/
/****VA Sweep Stakes Form****/
/********************/
$(".va-sweepstakes-form #state").on('focusout change', function () {
    if ($(".va-sweepstakes-form #state option:selected").val() == "") {
        $(".va-sweepstakes-form #state").parent().find('.chosen-container-single').addClass('red-border');
        $(this).closest("div.col-xs-6").find("span.field-validation-valid").removeClass("d-none");
        var validationMessage = $(this).closest("div.col-xs-6")[0].dataset.requiredMessage;
        $(this).closest("div.col-xs-6").find("span.field-validation-valid").text(validationMessage);
        state = true;
        return;
    } else {
        $(".va-sweepstakes-form #state").parent().find('.chosen-container-single').removeClass('red-border');
        $(this).closest("div.col-xs-6").find("span.field-validation-valid").addClass("d-none");
        state = false;
        return;
    }
});
$(".va-sweepstakes-form .submit").on('click', function (event) {
    $(this).hide();
    if (fname === true || lname === true || streetaddress == true || email === true || phone === true || city === true || state == true || zipcode == true || militarystatus == true || ownahome == true || dob == true) {
        event.preventDefault();
        $("input[name='fname'],input[name='lname'],input[name='email'],input[name='phone'],input[name='zip'],input[name='StreetAddress'],#militarystatus,#isownhome,input[name='dob'],#state,input[name='City']").blur();
        $(this).show();

        document.getElementById("formValidationSummary").classList.remove("d-none");
        $("#formValidationSummaryContainer")[0].focus();
    }
    else {
        $("#divWait").show();
        $(".field-validation-valid.text-danger").addClass("d-none");
    }
});

$(".shawn-sweepstakes-form .submit").on('click', function (event) {
    $(this).hide();
    if (fname === true || lname === true || email === true || phone === true) {
        event.preventDefault();
        $("input[name='fname'],input[name='lname'],input[name='email'],input[name='phone']").blur();
        $(this).show();

        document.getElementById("formValidationSummary").classList.remove("d-none");
        $("#formValidationSummaryContainer")[0].focus();
    }
    else {
        $("#divWait").show();
        $(".field-validation-valid.text-danger").addClass("d-none");
    }
});


/*********************/
/*Button Click Action Confirmation*/
/*********************/
$(document).ready(function () {
    $('[data-confirm]').click(function (e) {
        if (!confirm(jQuery(this).attr("data-confirm"))) {
            e.preventDefault();
        }
    });
    if ($('.GOTCForm').length > 0) {
        $('#BestDate').val(new Date().toJSON().slice(0, 10));

        $(function () {
            var d = new Date(),
                h = d.getHours(),
                m = d.getMinutes();
            if (h < 10) h = '0' + h;
            if (m < 10) m = '0' + m;
            $('#BestTime').each(function () {
                $(this).attr({ 'value': h + ':' + m });
            });
        });

    }
    //if ($("#vasweepstakesform").length > 0) {
    //    $('#dob').val(new Date().toJSON().slice(0, 10));
    //}
});

/***************************/
/*Show Form Functionality*/

//$('#showLOQuoteForm').click(function(){
//    $('#divLoanOfficerGetAQuote').show();
//    $('#divLoanOfficerDetails').hide();
//});

$(document).on("click", "#showLOQuoteForm", function () {
    $('.flip-container').toggleClass('hover');
});

$(".show_accessible").on('click', function (event) {
    $.getScript("/embrace/js/accessibility.js", function () {
        $(".show_accessible").parent().hide();
        setTimeout(
            function () {
                $("#INDmenu-btn").click();
            },
            600);
    });
});

//Lazy Loading functionality 

function registerListener(event, func) {
    if (window.addEventListener) {
        window.addEventListener(event, func)
    } else {
        window.attachEvent('on' + event, func)
    }
}



function isInViewport(el) {
    var rect = el.getBoundingClientRect();

    return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&

        rect.top <= (
            window.innerHeight ||
            document.documentElement.clientHeight) &&

        rect.left <= (
            window.innerWidth ||
            document.documentElement.clientWidth)
    );
}

function lazyLoad() {

    var lazy = document.getElementsByClassName('lazy');

    for (var i = 0; i < lazy.length; i++) {
        if (isInViewport(lazy[i])) {
            lazy[i].src =
                lazy[i].getAttribute('data-src');
        }
    }
}

registerListener('load', lazyLoad);
registerListener('scroll', lazyLoad);

$(".col-xs-6 .chosen-container input")
    .attr("aria-label", ariaState);

$(".recruiting-talk-form input.chosen-focus-input")
    .attr("aria-label", ariaState);

$(".contact-us-form .state-list input.chosen-focus-input")
    .attr("aria-label", ariaState);

$(".contact-us-form .question-list input.chosen-focus-input")
    .attr("aria-label", ariaQuestion);

$("#FindLoanOfficer input.chosen-focus-input")
    .attr("aria-label", ariaSearchState);

$(".military-status-list input.chosen-focus-input")
    .attr("aria-label", ariamilitaryStatus);

$(".own-a-home-list input.chosen-focus-input")
    .attr("aria-label", ariaownAHome);

$(document).stop().on("keydown", "a.accordion-toggler.getaquote", function (e) {
    if (event.keyCode == '32') {
        e.preventDefault();
        this.click();
    }
});

$("#state option").each(function (i) {
    var optionValue = $(this).text().trim();
    $(this).attr("aria-label", optionValue);
});

$("#question option").each(function (i) {
    var optionValue = $(this).text().trim();
    $(this).attr("aria-label", optionValue);
});

$("#militarystatus option").each(function (i) {
    var optionValue = $(this).text().trim();
    $(this).attr("aria-label", optionValue);
});

$("#isownhome option").each(function (i) {
    var optionValue = $(this).text().trim();
    $(this).attr("aria-label", optionValue);
});

$('.ybtn.purchaserate, .buttons__item.purchasebutton').click(function () {
    var purpose = 'purchase';
    BB.api.workflowInit({ loan_purpose: purpose });
    BB.api.openModal("leadWorkflow");
});
$('.ybtn.refinancerate, .buttons__item.refinancebutton').click(function () {
    var purpose = 'refinance';
    BB.api.workflowInit({ loan_purpose: purpose });
    BB.api.openModal("leadWorkflow");
});


$(".bbgetstartedbutton").click(function () {
    BB.api.openModal('leadWorkflow');
});

$(".bbLOGetAQuote").click(function () {
    BB.api.openModal('leadWorkflow');
})
$('.bb_button_type.purchase').click(function () {
    var purpose = 'purchase';
    BB.api.workflowInit({ loan_purpose: purpose });
    BB.api.openModal("leadWorkflow");
});
$('.bb_button_type.refinance').click(function () {
    var purpose = 'refinance';
    BB.api.workflowInit({ loan_purpose: purpose });
    BB.api.openModal("leadWorkflow");
});




/*LO Experience SEO Improvement */
//$("input[name='yearstarted']").on('focusout change', function () {
//    if ($(this).val().trim() == "") {
//        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
//        $(this).addClass('red-border');
//        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
//        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
//        yearstarted = true;
//    } else {
//        $(this).removeClass('red-border');
//        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
//        yearstarted = false;
//    }
//});

//$("input[name='yearstarted']").blur(function () {
//    if ($(this).val().trim() == "") {
//        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
//        $(this).addClass('red-border');
//        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
//        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
//        yearstarted = true;
//    } else {
//        $(this).removeClass('red-border');
//        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
//        yearstarted = false;
//    }
//});
//$("input[name='businesshours']").on('focusout change', function () {
//    if ($(this).val().trim() == "") {
//        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
//        $(this).addClass('red-border');
//        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
//        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
//        businesshours = true;
//    } else {
//        $(this).removeClass('red-border');
//        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
//        businesshours = false;
//    }
//});

//$("input[name='businesshours']").blur(function () {
//    if ($(this).val().trim() == "") {
//        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
//        $(this).addClass('red-border');
//        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
//        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
//        businesshours = true;
//    } else {
//        $(this).removeClass('red-border');
//        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
//        businesshours = false;
//    }
//});
//$(".loexperienceform #loanOfficer").chosen().change(function () {

//    if ($("#loanOfficer option:selected").val() == "") {
//        $("#loanOfficer").parent().find('.chosen-container-single').addClass('red-border');
//        loanofficer = true;
//        $("#loanOfficer").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariaSearchLO);
//    } else {
//        var ariaSelected = $("#loanOfficer option:selected").text().trim() + " selected";
//        $("#loanOfficer").parent().find('.chosen-container-single').removeClass('red-border');
//        loanofficer = false;
//        $('#hdnloanOfficerNameText').val($('#loanOfficer option:selected').text());
//        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
//        $("#loanOfficer").parent().find(".chosen-container-single .chosen-single input").attr("aria-label", ariaSelected);
//    }
//});

//$(".loexperienceform #loanOfficer").blur(function () {
//    if ($("#loanOfficer option:selected").val() == "") {
//        $("#loanOfficer").parent().find('.chosen-container-single').addClass('red-border');
//        $(this).closest("div").find("span.field-validation-valid").removeClass("d-none");
//        var validationMessage = $(this).closest("div")[0].dataset.requiredMessage;
//        $(this).closest("div").find("span.field-validation-valid").text(validationMessage);
//        loanofficer = true;
//    } else {
//        $("#loanOfficer").parent().find('.chosen-container-single').removeClass('red-border');
//        $(this).closest("div").find("span.field-validation-valid").addClass("d-none");
//        loanofficer = false;
//    }
//});
//$("#submitloexpform").on('click', async function (event) {
//    event.preventDefault();
//    //let captchaToken = await generateCaptchaKey('LOExperienceForm');

//    //if (captchaToken != '') {
//    //    // Inject the token into your hidden field for server-side verification
//    //    document.getElementById('g-recaptcha-response').value = captchaToken;
//    //    captcha = false;
//    //    $('.captcha-error').hide();
//    //} else {
//    //    $('.captcha-error').show();
//    //    captcha = true;
//    //}
//    // --- end reCAPTCHA v3 block ---
//    captcha = false;

//    if (loanofficer === true || yearstarted === true || businesshours === true|| captcha == true) {
//        $("input[name='yearstarted'],input[name='businesshours'],#loanOfficer").blur();
//        $(this).show();
//        document.getElementById("formValidationSummary").classList.remove("d-none");
//        $("#formValidationSummaryContainer")[0].focus();
//    }
//    else {
//        $(this).hide();
//        $("#divWait").show();
//        $(".field-validation-valid.text-danger").addClass("d-none");
//        document.getElementById("formValidationSummary").classList.add("d-none");
//        // Trigger the actual form submission now that token is in place
//        $("#formValidationSummaryContainer")[0].blur();
//        $("#submitloexpform").closest("form")[0].submit();
//    }
//});


/* LO Experience SEO Improvement */

// Shows or hides the error for one field. Returns true if valid.
function setFieldState($row, $highlight, isValid) {
    var $msg = $row.find("span.field-validation-valid");
    if (isValid) {
        $highlight.removeClass("red-border");
        $msg.addClass("d-none");
    } else {
        $highlight.addClass("red-border");
        $msg.text($row.data("requiredMessage")).removeClass("d-none");
    }
    return isValid;
}

function validateTextField(name) {
    var $input = $(".loexperienceform input[name='" + name + "']");
    var isValid = $.trim($input.val()) !== "";
    return setFieldState($input.closest(".input-row"), $input, isValid);
}

function validateLoanOfficer() {
    var $select = $(".loexperienceform #loanOfficer");
    var $chosen = $select.parent().find(".chosen-container-single");
    var $chosenInput = $chosen.find(".chosen-single input");
    var isValid = !!$select.val();

    setFieldState($select.closest(".input-row"), $chosen, isValid);

    if (isValid) {
        var selectedText = $select.find("option:selected").text().trim();
        $("#hdnloanOfficerNameText").val(selectedText);
        $chosenInput.attr("aria-label", selectedText + " selected");
    } else {
        $chosenInput.attr("aria-label", ariaSearchLO);
    }
    return isValid;
}

// Live validation while the user fills in the form //, input[name='businesshours']
$(".loexperienceform").on("focusout change",
    "input[name='yearstarted']",
    function () { validateTextField(this.name); });

$(".loexperienceform #loanOfficer").chosen().on("change", validateLoanOfficer);

$(document).on("mousedown", "#submitloexpform", function (event) {
    event.preventDefault();
});

$("#submitloexpform").on("click", async function (event) {
    event.preventDefault();

    // Run all validators (no short-circuit) so every error is shown
    var loValid = validateLoanOfficer();
    var yearValid = validateTextField("yearstarted");
    //var hoursValid = validateTextField("businesshours");

 
    let captchaToken = await generateCaptchaKey('LOExperienceForm');
    if (captchaToken != '') {
        document.getElementById('g-recaptcha-response').value = captchaToken;
        $('.captcha-error').hide();
        captcha = true;
    } else {
        $('.captcha-error').show();
        captcha = false;
    }


    // --- end reCAPTCHA v3 block ---
    //&& hoursValid 
    if (!(loValid && yearValid && captcha)) {
        $("#formValidationSummary").removeClass("d-none");
        $("#formValidationSummaryContainer")[0].focus();
        return;
    }

    $(this).hide();
    $("#divWait").show();
    $("#formValidationSummary").addClass("d-none");
    $(this).closest("form")[0].submit();
});